const UserReducer = (state, action) => {
  switch (action.type) {
    case 'SET_USER': {
      return { ...state, user: action.payload };
    }

    case 'SET_FAVORITE': {
      return { ...state, favoriteList: action.payload };
    }

    default:
      throw new Error();
  }
};

export default UserReducer;
